var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4,
    d: "m10 3 1.408 3.662c.198.513.297.77.45.986a2.1 2.1 0 0 0 .494.494c.216.154.473.252.986.45L17 10l-3.662 1.408c-.513.198-.77.297-.985.45a2.1 2.1 0 0 0-.495.494c-.154.216-.252.473-.45.986L10 17l-1.408-3.662c-.198-.513-.296-.77-.45-.985a2.1 2.1 0 0 0-.494-.495c-.216-.154-.473-.252-.986-.45L3 10l3.662-1.408c.513-.198.77-.296.986-.45a2.1 2.1 0 0 0 .494-.494c.154-.216.252-.473.45-.986z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.403bd883.svg";
export { ForwardRef as ReactComponent };